import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import Dialog from '../Dialog'
import Txt from '../Txt'

const ConfirmationDialog = (props) => {
  const { open, title, description, loading, onClose } = props

  const onCancel = () => onClose(false)

  const onAccept = () => onClose(true)

  return (
    <Dialog
      open={open}
      title={title}
      action='Accept'
      onAction={onAccept}
      onClose={onCancel}
      loading={loading}
      actionButtonTestID='confirmationDialogConfirmButton'
    >
      <View>
        <Txt
          text={description}
          identity='body2'
        />
      </View>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func
}

export default ConfirmationDialog
